module.exports = ".online {\r\n    color: white;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/server-console-1/server/server.component.css
// module id = ./src/app/components/server-console-1/server/server.component.css
// module chunks = main